export const selectedChip = {
  backgroundColor: "#295FFF",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer",
  "&:hover": { backgroundColor: "#507CFF", color: "#fff" },
};

export const unselectedChip = {
  backgroundColor: "transparent",
  color: "#64748B",
  fontWeight: "normal",
  boxShadow: "none",
  cursor: "pointer",
  "&:hover": { backgroundColor: "#507CFF", color: "#fff", boxShadow: "none" },
};

export const outlinedFieldHover = (borderRadius: string) => ({
  "& .MuiOutlinedInput-root": { backgroundColor: "#fff", borderRadius },
  "& .MuiOutlinedInput-root:hover:not(.Mui-focused)": {
    backgroundColor: "#F5F8FF",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
    {
      borderColor: "#003FFB",
      borderWidth: "1px",
    },
  "& .MuiInputLabel-root.Mui-focused": { color: "#003FFB" },
});
